module.exports = kolibriCoreAppGlobal.utils.browserInfo;